import React, { useEffect, useCallback, useState} from 'react';
import {useInterval} from "components/hooks/useInterval.js";
import PlayButton from "components/user/PlayButton.js";
import {connect} from 'react-redux';
import Tone from 'tone';
const WIDTH = 240;

const AudioPlayer = ({creator, audioUnit}) => { 
    let [playing, setPlaying] = useState(false);
    let [playTime, setPlayTime] = useState(undefined);
    let [progress, setProgress] = useState(0);

    const onTick = useCallback(() => {
        let diff = Tone.Master.context.currentTime - playTime;
        if (playing) {
            setProgress(diff / audioUnit.duration);
        }
    }, [playing, setProgress, playTime]);

    useInterval(onTick, 1000);
    const onClickPlay = useCallback(() => {
        if (playing) {
            audioUnit.stopSound();
        } else {
            audioUnit.playSound(0);
        }
        setPlaying(!playing);
        setProgress(0);
        setPlayTime(Tone.Master.context.currentTime);
    }, [playing, setProgress, setPlaying, audioUnit]);

    useEffect(() => {
        return () => audioUnit.stopSound();
    }, []);

    progress = Math.min(100, progress);

    return (
        <div className="audio-player">
          <PlayButton isPlaying={playing}
                      play={onClickPlay}/>
          <div className="play-time-and-slider">
          <div className="play-slider">
            <div
              style={{width: WIDTH * progress}}
              className="play-slider-inner">
            </div>
          </div>
            <div className="play-time">
              <div className="time">
              {formatTime(progress*audioUnit.duration)} / {formatTime(audioUnit.duration)}
              </div>
              <div className="creator">
                {truncate(creator)}
              </div>
            </div>
            <div className="song-title-and-author">
              <div className="song-title">
              Psilocybin
              </div>
              <div className="song-creator">
                Keyon Christ
              </div>
            </div>
          </div>
        </div>);
}

export const truncate = (creator) => {
    return creator.slice(0, 4) + '...' + creator.slice(-4);
};

const formatTime = (time) => {
    if (!time) {
        time = 0;
    }
    let minutes = Math.floor(time/60);
    let seconds = Math.floor(time - minutes * 60);
    if (seconds < 10) {
        seconds = '0' + seconds;
    }

    return `${minutes}:${seconds}`;

}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioPlayer);
